import script from "./MassIndex.vue?vue&type=script&lang=js"
export * from "./MassIndex.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__